module.exports = __webpack_public_path__ + "static/media/pic5.3204ac08.jpg";